export default __webpack_public_path__ + "static/media/boatimage.169d1414.jpg";